import { render, staticRenderFns } from "./AddressListList.vue?vue&type=template&id=0efa1ed6&scoped=true&"
import script from "./AddressListList.vue?vue&type=script&lang=js&"
export * from "./AddressListList.vue?vue&type=script&lang=js&"
import style0 from "./AddressListList.vue?vue&type=style&index=0&id=0efa1ed6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa1ed6",
  null
  
)

export default component.exports